<template>
  <div>
    <div id="contact_info" class="contact_info information-grid">
      <contact-info-box
        id="customer-contact"
        badge="1"
        title="Contact Information"
        :closed="openBox != 0"
        @opened="openBox = 0"
        :active="customerLocal.Email || customerLocal.FirstName || customerLocal.LastName || customerLocal.PhoneSubscriberNumber"
      >
        <template v-slot:active>
          <div class="active-layout-grid">
            <div class="contact-input">
              <fieldset>
                <label class="text_size-large" for="email">Email</label>
                <input
                  class="text_size-small"
                  :style="validContactInfo.email == -1 ? 'border-color: red' : ''"
                  id="email"
                  type="email"
                  v-model="customerLocal.Email"
                  autocomplete="on"
                  @blur="
                    saveCustomerLocal(true);
                    canValidateEmailFlag = true;
                    displayValidationMark('Email');
                  "
                />
                <div v-if="validContactInfo.email != 0" class="v-icon" :class="validContactInfo.email == 1 ? 'valid' : 'invalid'"></div>
              </fieldset>
              <small v-if="validContactInfo.email == -1" class="error" style="display: block;">Enter a valid email address</small>
            </div>

            <div class="contact-input">
              <fieldset>
                <label class="text_size-large">First name</label>
                <input
                  :class="{ 'border-red': !customerValid.firstName }"
                  @blur="
                    saveCustomerLocal(true);
                    displayValidationMark('FirstName');
                  "
                  :style="validContactInfo.firstName == -1 ? 'border-color: red' : ''"
                  type="text"
                  v-model="customerLocal.FirstName"
                  autocomplete="on"
                />
                <div v-if="validContactInfo.firstName != 0" class="v-icon" :class="validContactInfo.firstName == 1 ? 'valid' : 'invalid'"></div>
              </fieldset>
              <small v-if="validContactInfo.firstName == -1" class="error" style="display: block;">This field is required</small>
            </div>

            <div class="contact-input">
              <fieldset>
                <label class="text_size-large">Last name</label>
                <input
                  @blur="
                    saveCustomerLocal(true);
                    displayValidationMark('LastName');
                  "
                  type="text"
                  :class="{ 'border-red': !customerValid.lastName }"
                  :style="validContactInfo.lastName == -1 ? 'border-color: red' : ''"
                  v-model="customerLocal.LastName"
                  autocomplete="on"
                />
                <div v-if="validContactInfo.lastName != 0" class="v-icon" :class="validContactInfo.lastName == 1 ? 'valid' : 'invalid'"></div>
              </fieldset>
              <small v-if="validContactInfo.lastName == -1" class="error" style="display: block;">This field is required</small>
            </div>

            <div id="phoneNumberInput" class="contact-input" v-if="customer">
              <label class="text_size-large">Phone Number</label>
              <div id="pni-fields">
                <fieldset
                  class="select"
                  style="max-width: 85px;"
                  :style="validContactInfo.number == -1 ? 'border-color:red' : ''"
                  v-if="countryCodes"
                >
                  <select
                    @blur="saveCustomerLocal(true)"
                    :style="'background-image: url(' + countryFlag + '), ' + chevron"
                    class="form-control form-control-lg custom-select"
                    id="countryCode"
                    name="countryCode"
                    v-model="customerLocal.PhoneCountryKey"
                    data-v-validate
                    style="color:white;"
                    data-vv-rules="required"
                    data-class="{'form-control-danger': errors.has('countryCode') }"
                    autocomplete="off"
                  >
                    <option v-if="firstCountryOption" style="color: black;" selected :value="firstCountryOption.CountryKey"
                      >{{ firstCountryOption.Name }} ({{ firstCountryOption.E164 }})</option
                    >
                    <option :selected="!firstCountryOption" style="color: black;" :value="usCountryOption.CountryKey"
                      >{{ usCountryOption.Name }} ({{ usCountryOption.E164 }})</option
                    >
                    <template v-for="(country, n) in countryCodes">
                      <option style="color: black;" :key="'contact-info-country-codes-' + country.CountryKey + '-' + n" :value="country.CountryKey"
                        >{{ country.Name }} ({{ country.E164 }})</option
                      >
                    </template>
                  </select>
                  <small v-if="!customer.PhoneCountryKey" class="error" style="display: block;">Select your country</small>
                </fieldset>

                <fieldset style="max-width: 100px;" :style="validContactInfo.number == -1 ? 'border-color:red' : ''">
                  <input
                    @blur="
                      saveCustomerLocal(true);
                      displayValidationMark('Number');
                    "
                    v-model="customerLocal.PhoneAreaCode"
                    type="tel"
                    placeholder="Area"
                    autocomplete="tel-area-code"
                    maxlength="3"
                  />
                  <small v-if="!customerValid.phoneAreaCode" class="error" style="display: block;">Enter area code</small>
                </fieldset>

                <fieldset :style="validContactInfo.number == -1 ? 'border-color:red' : ''">
                  <!-- <label style="top: -5px; opacity: 1;">Phone Number</label> -->
                  <input
                    @blur="
                      saveCustomerLocal(true);
                      canValidateNumberFlag = true;
                      displayValidationMark('Number');
                    "
                    ref="phoneSubscriberNumber"
                    id="phoneSubscriberNumber"
                    v-model="customerLocal.PhoneSubscriberNumber"
                    type="tel"
                    placeholder="Number"
                    autocomplete="tel-local"
                  />
                  <div
                    v-if="validContactInfo.number != 0"
                    class="v-icon"
                    :class="validContactInfo.number == 1 ? 'valid' : 'invalid'"
                    :style="validContactInfo.number != -0 ? 'transform: translateY(-50%);' : ''"
                  ></div>
                </fieldset>
              </div>
              <small v-if="validContactInfo.number == -1" class="error" style="display: block;">Enter a valid phone number</small>
            </div>
            <div class="ticket-agreement">
              <check-input :value="customerLocal.EmailOptIn" @input="toggleEmailOptIn()" />
              <label @click="toggleEmailOptIn()">
                <span>Do you want to join our mailing list?</span>
              </label>
            </div>
            <div class="ticket-agreement" v-if="order.HasTickets && order.EnableDigitalTickets">
              <check-input :value="customerLocal.ApprovedTextTickets" @input="toggleTextApproval()" />
              <div @click="toggleTextApproval()">
                <span>Text me my ticket(s)</span>
                <p>
                  Standard messaging rates may apply. Tickets are also included in your confirmation email.
                </p>
              </div>
            </div>

            <div class="contact-input">
              <button class="button blue focus findFocus wide-cart-btn" @click="validateContactInfo()">
                <span v-if="emailValidLoading"><loader style="padding:0px;"/></span>
                <span class="text_size-large" v-else>Next</span>
              </button>
            </div>
          </div>
        </template>
        <template v-slot:summary>
          <div class="summary-wrapper text_size-medium">
            <div class="summary-entry" v-if="customer.Email">
              {{ customer.Email }}
            </div>
            <div class="summary-entry" v-if="customerName">
              {{ customerName }}
            </div>
            <div class="summary-entry" v-if="customerPhoneNumber">
              {{ customerPhoneNumber }}
            </div>
          </div>
        </template>
      </contact-info-box>

      <contact-info-box
        v-for="(activity, idx) in customFieldActivities"
        class="activity-info"
        :id="'activity-info-' + `${idx + 2}`"
        :badge="idx + 2"
        :title="activity.Name + ' information'"
        :subtitle="activity.SelectedTimes.length == 1 ? activitySubstring(activity) : activity.SelectedTimes.length.toString() + ' time slots'"
        :closed="openBox != idx + 2"
        :active="isActive(activity)"
        @opened="openBox = idx + 2"
        v-bind:key="'info-' + activity.OrderEntityKey"
      >
        <template v-slot:active>
          <div class="active-layout-grid">
            <!-- instructions -->
            <div class="activity-instructions text_size-medium">
              <span> This activity requires additional information to continue. Please complete the following: </span><span>*required</span>
            </div>
            <div class="cf-wrapper" v-if="activity.CustomFields">
              <custom-field
                v-for="field in activity.CustomFields"
                :field="field"
                :formSubmitted="formSubmitted"
                v-bind:key="activity.EntityHierarchyKey + '-' + field.ClientLocationCustomFieldKey"
                :ref="'customFieldGroup' + idx.toString()"
              ></custom-field>
            </div>
            <!-- custom field questions-->
            <div class="timeslot-grid" v-for="time in activity.SelectedTimes" v-bind:key="'customfield-' + time.OrderEntityTimeKey">
              <!-- full width line across card -->
              <div v-if="activity.CustomFields" style="border-top: 1px solid var(--border-color);" />
              <div class="timeslot text_size-medium" v-if="activity.SelectedTimes.length > 1" style="padding: 0 var(--outer-padding);">
                {{ timeslotSubstring(time) }}
              </div>
              <div class="rate-group" v-for="(group, idx2) in time.Rates" :key="idx2" :style="group.Participants > 0 ? '' : 'display: none'">
                <div class="group-name text_size-medium-small" v-if="group.CustomFieldParticipants.length">{{ group.Name }} Information</div>
                <div class="group-participant-grid">
                  <div class="activity-participant" v-for="(participant, idx3) in group.CustomFieldParticipants" v-bind:key="idx3">
                    <div class="active-rate-name text_size-medium">
                      <span>{{ participant.Heading }}</span>
                    </div>
                    <div style="border-top: 1px solid var(--border-color);"></div>
                    <div class="rate-fields">
                      <custom-field
                        v-for="(field, idx4) in participant.CustomFields"
                        :field="field"
                        :formSubmitted="formSubmitted"
                        :key="idx4"
                        :ref="'customFieldGroup' + idx.toString()"
                      ></custom-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- next button -->
            <div class="nxt-btn-wrapper">
              <!-- @click="nextBox($event, nextActivityBox(idx))" -->
              <button class="button blue focus findFocus wide-cart-btn  text_size-large" @click="validateCustomFieldGroup(idx)">
                Next
              </button>
            </div>
          </div>
        </template>
        <template v-slot:summary>
          <div class="summary-wrapper text_size-medium" v-show="isActive(activity)">
            <div class="outside-summary-entry" v-for="field in validCustomFields(activity)" v-bind:key="field.ClientLocationCustomFieldKey">
              {{ field.CustomFieldName }}:
              <i>{{ valueForCustomField(field) }}</i>
            </div>
            <div
              class="summary-entry-list"
              v-for="time in activity.SelectedTimes"
              v-bind:key="time.TimeString + ';' + time.OrderEntityTimeKey"
              v-show="anyValidFields(time)"
            >
              <div v-if="anyValidFields(time) && activity.SelectedTimes.length > 1" class="timeslot text_size-medium">
                {{ timeslotSubstring(time) }}
              </div>
              <div
                class="summary-rate"
                v-for="rate in filterCustomFields(time.Rates)"
                v-bind:key="rate.Heading + '-' + rate.OrderEntityTimeRateGUID"
                v-show="validCustomFields(rate).length > 0"
              >
                <div class="summary-rate-name text_size-medium" v-if="validCustomFields(rate).length > 0">
                  {{ rate.Heading }}
                </div>
                <div class="summary-rate-items">
                  <div
                    class="summary-entry text_size-medium"
                    v-for="field in validCustomFields(rate)"
                    v-bind:key="'summary-' + field.ClientLocationCustomFieldKey"
                  >
                    {{ field.CustomFieldName }}:
                    <i>{{ valueForCustomField(field) }}</i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </contact-info-box>

      <contact-info-box
        id="additional-info"
        :badge="additionalInfoBadgeCount"
        title="Additional Information"
        :closed="openBox != additionalInfoBadgeCount"
        @opened="openBox = additionalInfoBadgeCount"
        :active="additionalInfoActive"
        v-if="hasAdditionalInfo"
      >
        <template v-slot:active>
          <div class="active-wrapper">
            <div class="active-layout-grid">
              <fieldset v-if="customer && heardAboutUs.length > 1">
                <label class="text_size-medium">How did you hear about us?*</label>
                <select
                  @blur="saveCustomerLocal(false)"
                  v-model="customerLocal.ClientLocationHeardAboutUsKey"
                  class="form-control form-control-lg custom-select"
                  id="heardAboutUs"
                  name="heardAboutUs"
                  data-v-validate
                  data-vv-rules="required|numeric"
                  data-class="{'form-control-danger': errors.has('heardAboutUs') }"
                  :style="!heardAboutUsValid && customerLocal.ClientLocationHeardAboutUsKey != 0 ? 'border: 2px solid red;' : ''"
                  required
                >
                  <option value="null" disabled selected hidden>Select</option>
                  <option
                    v-for="opt in heardAboutUs"
                    :key="'contact-info-heard-about-' + opt.ClientLocationHeardAboutUsKey"
                    :value="opt.ClientLocationHeardAboutUsKey"
                    >{{ opt.Description }}</option
                  >
                </select>

                <!-- <small
                  v-if="!customerValid.clientLocationHeardAboutUsKey"
                  class="error"
                  style="display: block;"
                  >Select one</small
                > -->

                <div v-show="customerLocal.ClientLocationHeardAboutUsKey == 0" style="margin-top: 4px;">
                  <input
                    @blur="saveCustomerLocal(false)"
                    :style="!heardAboutUsValid ? 'border: 2px solid red' : ''"
                    type="text"
                    v-model="customerLocal.HeardAboutUsOther"
                    placeholder="How did you hear about us?"
                  />
                </div>
                <div v-if="!heardAboutUsValid" class="text_color-error text_size-small" style="display: block; margin-top: 2px;">
                  Required
                </div>
              </fieldset>

              <!-- <label v-if="customerLocal.HeardAboutUsOther"
                  >How did you hear about us?</label
                > -->
              <!-- <small
                  v-if="!customerValid.heardAboutUsOther"
                  class="error"
                  style="display: block;"
                  >Enter answer</small
                > -->

              <!-- <transition name="slide-vertical">
                <p
                  v-show="
                    formSubmitted &&
                      hasRequirements &&
                      (!customerValid.agreed || !allFieldsAnswered)
                  "
                  class="error mb-0"
                >
                  Please confirm the following:
                </p>
              </transition> -->

              <div v-show="hasRequirements" class="bool-container">
                <div style="margin-bottom: 4px;">
                  Please agree:
                </div>
                <div class="checkbox-flex">
                  <div class="mr-2">
                    <span class="check_ui">
                      <input
                        @click="requirementsClick"
                        :checked="customerLocal.Agreed"
                        id="customer-agreed-checkbox"
                        type="checkbox"
                        :blur="validateRequirements()"
                      />
                      <label
                        for="customer-agreed-checkbox"
                        :style="!hasReqValid ? 'border: 2px solid red; transition: none; box-shadow: none;' : ''"
                      ></label>
                    </span>
                  </div>

                  <p @click.prevent="showReqModal">
                    I understand the
                    <a href>Requirements to Participate</a>
                    and everyone in my party meets these requirements.*
                  </p>
                </div>
                <div v-if="!hasReqValid" class="text_color-error text_size-small" style="display: block;">
                  Required
                </div>
              </div>
              <!-- <pre>Agreed: {{ customerLocal.Agreed }} ({{ customer.Agreed }})</pre> -->
              <!-- Render out Custom Fields -->
              <custom-field
                :ref="'customFieldGroup' + additionalInfoBadgeCount.toString()"
                v-for="field in order.CustomFields"
                :field="field"
                :formSubmitted="formSubmitted"
                v-bind:key="field.ClientLocationCustomFieldKey"
              ></custom-field>
              <button class="button blue focus findFocus wide-cart-btn text_size-large" @click="validateAdditionalInfoBox()">
                Continue to payment
              </button>
            </div>
          </div>
        </template>
        <template v-slot:summary>
          <div class="summary-wrapper text_size-medium">
            <div class="summary-entry" v-if="customer.ClientLocationHeardAboutUsKey || customerLocal.HeardAboutUsOther">
              How did you hear about us?
              <span
                ><i>{{ customerHeardAboutUs }}</i></span
              >
            </div>
            <div class="summary-entry" v-if="customer.Agreed">
              Requirements to Participate:
              <span>
                <i>{{ customer.Agreed ? "Agreed" : "Not Confirmed" }}</i>
              </span>
            </div>
            <div class="summary-entry" v-for="field in customerCustomFields" v-bind:key="'summary-' + field.ClientLocationCustomFieldKey">
              {{ field.CustomFieldName }}:
              <i>{{ valueForCustomField(field) }}</i>
            </div>
          </div>
        </template>
      </contact-info-box>
      <pre>allFieldsAnswered: {{ allFieldsAnswered }}</pre>
      <pre>additionalInfoComplete: {{ additionalInfoComplete }} </pre>
      <pre>customer.ClientLocationHeardAboutUsKey: {{ customer.ClientLocationHeardAboutUsKey }} other: {{ customer.HeardAboutUsOther }}</pre>
      <pre>Agreed: {{ customerLocal.Agreed }} ({{ customer.Agreed }})</pre>
      <!--- ============================================ MODALS ============================================ - -->
    </div>
    <modal :modal="requirementsModal">
      <div v-for="(r, i) in hasRequirements" style="margin: 15px;" :key="'contact-info-has-requirements-' + i">
        <h5>{{ r.ActivityName }}</h5>
        <div v-html="r.Message"></div>
      </div>

      <template v-slot:footer>
        <a @click.prevent="requirementsAgree" style="margin: 10px 0; padding: 15px;" class="button blue next ml-1 mr-1">{{
          customer.Agreed ? "OK" : "I agree"
        }}</a>
      </template>
    </modal>

    <modal :modal="emailFeedbackModal">
      <p class="text-center pt-3 pb-2">
        Are you sure this is a real email address?
      </p>
      <p class="text-center pt-0 pb-2">
        <strong>{{ customer.Email }}</strong>
      </p>
      <template v-slot:footer>
        <button href @click.prevent="emailFeedbackModalTryAgain" class="button blue ml-0 focus">
          Try again
        </button>
        <button href @click.prevent="emailFeedbackModalForceValid($event)" class="button ml-1">
          Yes, it's real
        </button>
      </template>
    </modal>
    <!-- END MODALS -->
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import ContactInfoBox from "./ContactInfoBox.vue";
import CustomField from "./CustomField.vue";
import CustomFieldHelpers from "@/mixins/customFieldHelpers";
import Loader from "./Loader.vue";
import CheckInput from "./CheckInput.vue";

export default {
  name: "ContactInfo",
  mixins: [CustomFieldHelpers],
  components: { ContactInfoBox, CustomField, Loader, CheckInput },
  props: [
    "customer",
    "hasRequirements",
    "emailValid",
    "customerValid",
    "notes",
    "formSubmitted",
    "emailHasFailed",
    "paymentIsOpen",
    "requireEmailOptIn",
  ],
  data() {
    return {
      openBox: 0,
      customerLocal: false,
      requirementsModal: {
        id: "requirementsModal",
        show: false,
        shown: false,
        heading: "Requirements to Participate",
      },
      //emailValid: true,
      emailValidLoading: false,
      emailFeedbackModal: {
        show: false,
        hideHeader: true,
      },
      // object to denote validity of contact info
      // 0 == initial state; 1 = valid; -1 = invalid
      validContactInfo: {
        email: 0,
        firstName: 0,
        lastName: 0,
        number: 0,
      },
      canValidateNumberFlag: false, // used for on-the-fly input validation
      canValidateEmailFlag: false, // used for on-the-fly input validation
      hasReqValid: true,
      heardAboutUsValid: true,
      chevron: `url("data:image/svg+xml; utf8, <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'><polyline points='6 9 12 15 18 9'></polyline></svg>")`,
    };
  },
  created() {
    if (this.customer) {
      this.customerLocal = JSON.parse(JSON.stringify(this.customer));
    }
  },
  beforeMount() {
    // check if fields are valid once before loaded to DOM
    if (this.customerLocal.Email) this.displayValidationMark("Email");
    if (this.customerLocal.FirstName) this.displayValidationMark("FirstName");
    if (this.customerLocal.LastName) this.displayValidationMark("LastName");
    if (this.customerLocal.PhoneAreaCode && this.customerLocal.PhoneSubscriberNumber) {
      this.canValidateNumberFlag = true;
      this.displayValidationMark("Number");
    }

    this.openCartAt(); // on cart load, skips to first incomplete card
  },
  mounted() {
    // smooth scroll to first incomplete card
    let scrollTo = null;
    let headerHeight = document.querySelector("#sticky_tabs").getBoundingClientRect().height; // height of navigation header

    switch (this.openBox) {
      case -1:
        scrollTo = "#payment_card";
        break;
      case 0:
        break;
      case this.additionalInfoBadgeCount:
        scrollTo = "#additional-info";
        break;
      default:
        // console.log(this.openBox);
        scrollTo = `#activity-info-${this.openBox}`;
        break;
    }

    let top = document.querySelector(scrollTo).getBoundingClientRect().top - (headerHeight ? headerHeight : 0);
    window.scrollBy({
      top: top,
      left: 0,
      behavior: "smooth",
    });
  },
  watch: {
    customer: {
      handler(newVal) {
        if (!this.customerLocal && newVal) {
          this.customerLocal = JSON.parse(JSON.stringify(newVal));
        }
      },
      deep: true,
    },
    customerLocal: {
      handler(val) {
        this.updateCustomer(val);
      },
      deep: true,
    },
    paymentIsOpen: {
      handler(val) {
        if (val) {
          this.openBox = -1;
          // this.openBox = false;
        }
      },
    },
    openBox: {
      handler(val) {
        if (val >= 0) {
          this.$emit("shouldClosePayment");
        }
      },
    },
    "customerLocal.PhoneAreaCode": {
      handler(val) {
        this.displayValidationMark("Number"); // check validation on input changeover
        // the country is USA (196), and the areacode has 3 digits and no errors in area code
        // tab over to the phoneSubscriberNumber input
        if (val && val.length === 3 && this.customer.PhoneCountryKey === 196 && this.validContactInfo.number != -1) {
          // tab to other phone number field
          this.$refs.phoneSubscriberNumber.focus();
        }
      },
    },
    "customerLocal.PhoneSubscriberNumber": {
      handler(val) {
        this.displayValidationMark("Number");
      },
    },
    "customerLocal.Email": {
      handler(val) {
        this.displayValidationMark("Email");
      },
    },
  },
  methods: {
    ...mapActions(["saveOrderProgress", "isValidEmail"]),
    ...mapMutations(["updateCustomer"]),
    openCartAt() {
      if (this.contactInfoComplete) this.openBox = 2;
      else return;

      // check if all custom field activies are completed
      let activities = this.customFieldActivities;
      for (let i = 0; i < activities.length; i++) {
        if (this.validateCustomFields(activities[i])) this.openBox = i + 3;
        else return;
      }

      if (this.additionalInfoComplete) {
        this.openBox = -1; // close open boxes
        this.$emit("shouldOpenPayment");
      }
    },
    anyValidFields(time) {
      return this.filterCustomFields(time.Rates).some((f) => {
        return this.validCustomFields(f).length > 0;
      });
    },
    isActive(activity) {
      if (this.validCustomFields(activity).length) return true; // any valid fields at activity level
      return activity.SelectedTimes.every((time) => {
        if (this.anyValidFields(time)) return true; // any valid fields in time
        return this.anyValidFields(time);
      });
    },
    // checks if contact info fields are valid
    validateContactInfo(proceed = true) {
      let valid = true;
      for (const [key, value] of Object.entries(this.validContactInfo)) {
        if (value == -1) valid = false;
        if (value == 0) {
          valid = false;
          this.validContactInfo[key] = -1;
        }
      }
      if (valid && proceed) this.customerNextBox(2);
      else return valid;
    },
    // checks if an activity box custom fields are valid
    validateCustomFieldGroup(idx, proceed = true) {
      let valid = true;
      this.$refs["customFieldGroup" + idx.toString()].forEach((cf) => {
        if (cf.validateField()) valid = false;
      });

      if (valid && proceed) this.nextBox(idx + 3);
      // idx is 2 behind so +3
      else return valid;
    },
    validateAdditionalInfoBox() {
      let valid = true;
      // console.log("validateAdditionalInfoBox")
      // check heard about us
      if (this.disableHeardAboutUs) {
        this.heardAboutUsValid = true;
      } else {
        if (
          this.customer.ClientLocationHeardAboutUsKey == null ||
          (this.customer.ClientLocationHeardAboutUsKey == 0 && (!this.customer.HeardAboutUsOther || this.customer.HeardAboutUsOther == ""))
        ) {
          valid = false;
          // console.log("invalid 1")
          this.heardAboutUsValid = false;
        } else {
          this.heardAboutUsValid = true;
        }
      }

      // check requirements property
      if (this.hasRequirements) {
        if (!this.customerLocal.Agreed) {
          valid = false;
          // console.log("invalid 2")
          this.hasReqValid = false;
        } else {
          this.hasReqValid = true;
        }
      }

      // validate any required custom fields
      if (this.$refs[`customFieldGroup${this.additionalInfoBadgeCount.toString()}`]) {
        this.$refs[`customFieldGroup${this.additionalInfoBadgeCount.toString()}`].forEach((cf) => {
          if (cf.validateField()) {
            // console.log("invalid 3")
            valid = false;
          }
        });
      }
      // if valid, open payment box
      // console.log(valid)
      if (valid) {
        this.openBox = -1; // close open boxes
        this.$emit("shouldOpenPayment");
      }
    },
    // nextActivityBox(idx) {
    //   const nextActivity = this.customFieldActivities[idx + 1];
    //   if (!nextActivity) {
    //     return "additional";
    //   }
    //   return nextActivity.OrderEntityKey;
    // },
    timeslotSubstring(activity) {
      return activity.AppointmentTypeKey == 1 ? `${activity.AppointmentDate} ${activity.TimeString}` : "";
    },
    // return activity time string depending on appointmentTypeKey
    activitySubstring(activity) {
      return activity.AppointmentTypeKey == 1
        ? activity.AppointmentDayOfTheWeek +
            " " +
            activity.AppointmentMonth +
            activity.AppointmentDay +
            ", " +
            activity.AppointmentYear +
            " at " +
            activity.SelectedTimes[0].DisplayName
        : activity.AppointmentTypeKey == 2
        ? activity.AppointmentDayOfTheWeek + " " + activity.AppointmentMonth + activity.AppointmentDay + ", " + activity.AppointmentYear
        : "";
    },
    requirementsClick(e) {
      if (!this.requirementsModal.shown) {
        this.showReqModal();
        e.preventDefault();
      } else {
        this.customerLocal.Agreed = !this.customerLocal.Agreed;
      }
    },
    showReqModal() {
      this.requirementsModal.show = true;
      this.requirementsModal.shown = true;
    },
    // checks validity
    displayValidationMark(field) {
      switch (field) {
        case "FirstName":
          this.validContactInfo.firstName = this.customerLocal.FirstName != "" ? 1 : -1;
          break;

        case "LastName":
          this.validContactInfo.lastName = this.customerLocal.LastName != "" ? 1 : -1;
          break;

        case "Email":
          // regex check for email pattern
          let validEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            String(this.customerLocal.Email).toLowerCase()
          );

          if (validEmail) {
            this.validContactInfo.email = 1;
            this.canValidateEmailFlag = true;
          } else if (this.canValidateEmailFlag && !validEmail) this.validContactInfo.email = -1;

          break;

        case "Number":
          let testNum = this.customerLocal.PhoneAreaCode + this.customerLocal.PhoneSubscriberNumber;

          if (
            // US & Canada numbers
            this.customerLocal.PhoneCountryKey == 196 ||
            this.customerLocal.PhoneCountryKey == 31
          ) {
            if (this.canValidateNumberFlag) {
              // validate number string
              this.validContactInfo.number = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4}$/im.test(String(testNum)) ? 1 : -1;
            } else if (/[a-zA-Z]/g.test(testNum)) {
              // if fields contain a letter but not enough digits
              this.validContactInfo.number = -1;
            } else {
              if (testNum.length < 9) {
                // reset status flag back to 0
                this.validContactInfo.number = 0;
              }
              if (testNum.length == 9) {
                // correct # of digits -> can validate
                this.canValidateNumberFlag = true;
                displayValidationMark("Number");
              }
            }
          } else {
            // international number
            if (
              this.customerLocal.PhoneCountryKey &&
              this.customerLocal.PhoneAreaCode &&
              this.customerLocal.PhoneSubscriberNumber &&
              !/[a-zA-Z]/g.test(testNum)
            )
              this.validContactInfo.number = 1;
            else this.validContactInfo.number = -1;
          }
          break;
      }
    },
    customerNextBox(nextBoxName) {
      if (!this.contactInfoComplete) return; // contact info not valid

      this.$emit("updateEmailValid", true);
      this.$set(this, "emailValidLoading", true);
      this.isValidEmail({
        email: this.customerLocal.Email,
        callback: (json) => {
          if (json !== true && json !== false) {
            return;
          }
          this.$emit("updateEmailValid", json);
          if (json) {
            // email is valid
            this.$set(this, "emailValidLoading", false);
            if (nextBoxName == 2 && !this.hasAdditionalInfo) {
              this.validateAdditionalInfoBox();
            } else {
              this.nextBox(nextBoxName);
            }
          }
          setTimeout(() => {
            // show email verification modal
            this.$set(this, "emailValidLoading", false);
            this.emailFeedbackModal.show = !this.emailValid;
          }, 100);
        },
      });
    },
    nextBox(nextBoxIdx) {
      this.openBox = nextBoxIdx;
    },
    emailFeedbackModalTryAgain() {
      this.emailFeedbackModal.show = false;
      // focus and select email field
      document.getElementById("email").focus();
      document.getElementById("email").select();
    },
    emailFeedbackModalForceValid(e) {
      this.emailFeedbackModal.show = false;
      this.$emit("updateEmailValid", true);
      this.$emit("updateEmailHasFailed");
      this.nextBox(2);
    },
    saveCustomerLocal(isCustomerField = false) {
      this.updateCustomer(this.customerLocal);
      this.saveOrderProgress(isCustomerField);
    },
    requirementsAgree() {
      this.requirementsModal.show = false;
      this.$set(this.$store.state.order.Customer, "Agreed", true);
      this.saveOrderProgress(false);
    },
    // removes error border when user agrees
    validateRequirements() {
      if (!this.hasReqValid && this.customerLocal.Agreed) {
        this.hasReqValid = true;
        this.saveOrderProgress();
      }
    },
    toggleTextApproval() {
      console.log("toggleTextApproval");

      this.customerLocal.ApprovedTextTickets = !this.customerLocal.ApprovedTextTickets;
      this.saveCustomerLocal();
    },
    toggleEmailOptIn() {
      this.customerLocal.EmailOptIn = !this.customerLocal.EmailOptIn;
      this.saveCustomerLocal();
    },
  },
  computed: {
    ...mapState(["order"]),
    hasAdditionalInfo() {
      return this.heardAboutUs.length > 1 || this.hasRequirements || this.order.CustomFields.length > 0;
    },
    disableHeardAboutUs() {
      return this.heardAboutUs.length == 0;
    },
    additionalInfoBadgeCount() {
      return this.customFieldActivities.length + 2;
    },
    contactInfoComplete() {
      return (
        this.validContactInfo.firstName == 1 &&
        this.validContactInfo.lastName == 1 &&
        this.validContactInfo.email == 1 &&
        this.validContactInfo.number == 1
      );
    },
    firstCountryOption() {
      try {
        if (this.$store.state.client.CountryKey == 196) return null;
        return this.countryCodes.find((c) => c.CountryKey == this.client.CountryKey);
      } catch (e) {
        console.error(e);
      }
      return null;
    },
    usCountryOption() {
      return this.countryCodes.find((c) => c.CountryKey == 196);
    },
    additionalInfoComplete() {
      if (this.customer.ClientLocationHeardAboutUsKey == 0 && (!this.customer.HeardAboutUsOther || this.customer.HeardAboutUsOther == "")) {
        return false;
      }
      if (!this.customer.ClientLocationHeardAboutUsKey) {
        if (!this.customer.HeardAboutUsOther) return false;
      }
      if (this.hasRequirements.length && !this.customer.Agreed) {
        return false;
      }
      if (!this.validateCustomFields(this.order)) {
        return false;
      }
      return true;
    },
    // returns true if any additional fields are valid
    additionalInfoActive() {
      return (
        (this.customer.ClientLocationHeardAboutUsKey == 0 && (!this.customer.HeardAboutUsOther || this.customer.HeardAboutUsOther != "")) ||
        this.customer.ClientLocationHeardAboutUsKey ||
        (this.hasRequirements.length && this.customer.Agreed) ||
        this.order.CustomFields.some((f) => {
          if (f.IsRequired) return this.customFieldIsValid(f);
        })
      );
    },
    customerCustomFields() {
      return this.order.CustomFields.filter(
        (field) => field.Response_Text || field.Response_Boolean || field.Selected_ClientLocationCustomFieldResponseKeys.length
      );
    },
    customerHeardAboutUs() {
      if (this.customer.ClientLocationHeardAboutUsKey == 0) {
        return this.customer.HeardAboutUsOther;
      }
      if (!this.customer.ClientLocationHeardAboutUsKey) {
        return "No Response";
      }
      var response = this.heardAboutUs.find((item) => item.ClientLocationHeardAboutUsKey == this.customer.ClientLocationHeardAboutUsKey);
      if (response) {
        return response.Description;
      }
      return "No Response";
    },
    customerName() {
      if (this.customer.FirstName && this.customer.LastName) {
        return this.customer.FirstName + " " + this.customer.LastName;
      }
      return this.customer.LastName || this.customer.FirstName || false;
    },
    customerPhoneNumber() {
      var country = this.countryCodes.find((c) => c.CountryKey == this.customer.PhoneCountryKey);
      if (country && this.customer.PhoneAreaCode && this.customer.PhoneSubscriberNumber) {
        return "+" + country.E164 + " " + this.customer.PhoneAreaCode + "-" + this.customer.PhoneSubscriberNumber;
      }
      return false;
    },
    countryCodes() {
      return this.$store.state.client.Countries;
    },
    countryFlag() {
      var find = this.countryCodes.find((ele) => {
        return ele.CountryKey == this.customer.PhoneCountryKey;
      });
      if (!find) {
        return false;
      }
      return "/flags-master/flags/flags-iso/flat/64/" + find.CountryCode + ".png";
    },
    heardAboutUs() {
      //var opt = [];
      return this.$store.state.client.HeardAboutUs;
    },
  },
};
</script>

<style lang="scss">
.valid {
  background-image: url("data:image/svg+xml; utf8, <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' stroke-width='1.5' stroke='%230099FF' fill='none' stroke-linecap='round' stroke-linejoin='round'><path stroke='none' d='M0 0h24v24H0z' fill='none'/><path d='M5 12l5 5l10 -10' /></svg>");
}

.invalid {
  background-image: url("data:image/svg+xml; utf8, <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' stroke-width='1.5' stroke='red' fill='none' stroke-linecap='round' stroke-linejoin='round'><path stroke='none' d='M0 0h24v24H0z' fill='none'/> <circle cx='12' cy='12' r='9' /> <line x1='12' y1='8' x2='12' y2='12' /> <line x1='12' y1='16' x2='12.01' y2='16' /></svg>");
}

.v-icon {
  height: 18px;
  width: 18px;
  position: absolute;
  right: 3%;
  top: 50%;
}

.pad {
  padding: 5px 15px;
}
.inline.tooltip {
  display: inline-block;
}
.material-icons.adjust {
  position: relative;
  top: 5px;
}
.flex.topbox {
  align-items: flex-start;
}
.topbox .mr-2 {
  position: relative;
  top: 6px;
}
.form-error {
  border: 1px solid red;
  padding: 5px 10px;
  margin-bottom: 5px;
  border-radius: var(--input-border-radius);
}

button.next-button.button {
  margin: 15px 0px 0px !important;
  width: 100%;
}

button.disabled.blue {
  background-color: lightgray;
  border: 1px solid lightgray;
  cursor: not-allowed;
}

.rate-group {
  padding: 0 var(--outer-padding);
}

.activity-instructions {
  padding: var(--inner-padding) var(--outer-padding) 0;
  display: grid;
  grid-gap: calc(var(--inner-padding) / 2);
}

.cf-wrapper {
  padding: 0 var(--outer-padding);
  display: grid;
  grid-gap: var(--inner-padding);
}

.timeslot-grid {
  display: grid;
  grid-gap: var(--inner-padding);
}

.group-participant-grid {
  width: calc(100% - 2px); // subtract 2 pixels for border on each side
  position: relative;
  display: grid;
  grid-template-columns: calc(49% - 4px) calc(49% - 4px);
  grid-gap: var(--inner-padding);

  // mobile
  @media only screen and (max-width: 942px) {
    grid-template-columns: auto;
  }
}

.activity-participant {
  // border: 1px solid var(--border-color);
  border-radius: var(--card-border-radius);
  background: #f8f8f8;
  box-shadow: 0px 1px 3px #00000029;
  height: fit-content;
}
.summary-rate-name,
.active-rate-name {
  font-weight: bold;
  display: flex;
  align-items: center;
  padding: 15px;
}

.activity-time {
  padding: 0 0 4px;
}

.active-wrapper {
  padding: var(--inner-padding) var(--outer-padding) 0;
}

.group-name {
  margin-bottom: var(--inner-padding);
  text-transform: uppercase;
  font-weight: 500;
}

.active-rate-name {
  padding-bottom: 8px;
}

.summary-rate-name {
  padding: 0px 0;
  font-weight: 600;
}

.rate-fields {
  display: grid;
  grid-gap: var(--inner-padding);
  padding: 8px 15px var(--inner-padding);
}

.summary-entry {
  margin: 3px 0px;
}

.outside-summary-entry {
  padding: 4px 0;
  overflow: hidden;
}

.summary-wrapper {
  padding: 0 var(--outer-padding);

  > :first-child {
    margin-top: var(--inner-padding);
  }
}

.summary-entry-list {
}

.summary-rate {
  margin-top: calc(var(--inner-padding) / 2);
}

.information-grid {
  display: grid;
  grid-gap: var(--grid-gap);

  .active-layout-grid {
    display: grid;
    grid-gap: var(--inner-padding);
  }

  #customer-contact {
    .contact-input {
      padding: 0 var(--outer-padding);

      &:first-child {
        padding-top: var(--outer-padding);
      }
    }

    fieldset {
      margin: 0;
      display: grid;
      grid-template-columns: 100%;
    }

    input {
      font-size: 16px;
      height: 45px;
      border-radius: var(--input-border-radius);
      padding: 0 15px;
    }

    label {
      position: relative;
      white-space: nowrap;
      padding: 0 0 4px;
      margin: 0;
    }

    .custom-select {
      height: 45px;
      border-radius: var(--input-border-radius) 0 0 var(--input-border-radius);
      background-image: url("data:image/svg+xml; utf8, <svg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'><polyline points='6 9 12 15 18 9'></polyline></svg>");
    }

    button {
      margin: 0;
      padding: 0;
      border-radius: 4px;
    }

    .error {
      color: red;
      font-size: 12px;
      padding-top: 5px;
    }

    #phoneNumberInput {
      display: grid;
      position: relative;

      #pni-fields {
        display: grid;
        grid-template-columns: 85px 100px auto;

        fieldset {
          select,
          input {
            border: none;
          }

          border: 1px solid var(--border-color);
        }

        :first-child {
          border-top-left-radius: 3px;
          border-bottom-left-radius: 3px;
        }

        :last-child {
          border-left: none;
          border-top-right-radius: 3px;
          border-bottom-right-radius: 3px;
        }
      }
    }
  }

  .activity-info,
  #additional-info {
    fieldset {
      margin: 0;
      display: grid;
      grid-template-columns: 100%;
    }

    label {
      position: relative;
      padding: 0 0 4px;
      margin: 0;
    }

    input {
      font-size: 14px;
      height: 40px;
      padding: 2px;
      padding-left: 12px;
      border-radius: var(--input-border-radius);
    }

    .custom-select {
      height: 40px !important;
      border-radius: var(--input-border-radius);
      font-size: 15px;
      background-image: url("data:image/svg+xml; utf8, <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'><polyline points='6 9 12 15 18 9'></polyline></svg>");
      padding: 2px;
      padding-right: 30px;
      padding-left: 12px;

      // mobile
      @media only screen and (max-width: 942px) {
        font-size: 17px;
      }
    }

    textarea {
      font-size: 15px;
      padding: 8px 12px;
      margin: 0;

      // mobile
      @media only screen and (max-width: 942px) {
        font-size: 17px;
      }
    }

    .checkbox-flex {
      display: flex;
      align-items: center;

      label {
        padding: 0; // checkbox is a label for some reason...
      }

      p {
        margin-block: 0;
        margin-inline: 0;
        line-height: 110%;
      }
    }

    button {
      padding: 0;
      margin: 0;
      border-radius: var(--input-border-radius);
    }

    .timeslot {
      color: #353a3d;
      font-weight: 700;
      margin-top: 10px;
    }

    .nxt-btn-wrapper {
      padding: 0 var(--outer-padding);
    }
  }

  #additional-info {
    // override text_size classes
    label,
    .bool-container {
      font-size: 15px;
      // mobile
      @media only screen and (max-width: 942px) {
        font-size: 17px;
      }
    }
  }
}

.ticket-agreement {
  padding: 0 25px;
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: flex-start;
  font-size: 15px;

  .check_ui {
    flex-shrink: 0;
    flex-grow: 0;
    width: 24px;
    height: 24px;
    & > label {
      padding: 0 !important;
      outline: none !important;
    }
  }

  label,
  div:nth-child(2) {
    span {
      font-size: 15px;
      font-weight: bold;
    }

    p {
      font-size: 0.9em;
      margin: 2px 0;
    }
  }
}
</style>
